import { memo } from "react";
import type { OrderSummaryMode } from "./types";

export interface SummaryHeaderProps {
  /** Total item count across all carts */
  itemCount: number;
  /** Number of sellers/carts selected */
  sellerCount: number;
  /** Mode determines display style */
  mode: OrderSummaryMode;
}

/**
 * Header section of the order summary showing title, item count and supplier
 * count. The cart says "selected" (the buyer picks which suppliers to check
 * out, and the line is a live region as they do); checkout has no selection
 * left to make, so it states the count plain.
 */
export const SummaryHeader = memo(function SummaryHeader({
  itemCount,
  sellerCount,
  mode
}: SummaryHeaderProps) {
  const suppliers = `${sellerCount} ${sellerCount === 1 ? "supplier" : "suppliers"}`;

  return (
    <div className="border-b border-gray-200 px-6 py-4">
      <h2 className="text-lg font-semibold text-gray-900">Order Summary</h2>
      <p className="text-sm text-gray-500">
        {itemCount} {itemCount === 1 ? "item" : "items"}
        {mode === "cart" ? (
          <span aria-live="polite" aria-atomic="true">
            {" "}
            · {suppliers} selected
          </span>
        ) : (
          <span> · {suppliers}</span>
        )}
      </p>
    </div>
  );
});
